import { render, staticRenderFns } from "./BaseSelectOutlined.vue?vue&type=template&id=41045744&"
import script from "./BaseSelectOutlined.vue?vue&type=script&lang=js&"
export * from "./BaseSelectOutlined.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectOutlined.vue?vue&type=style&index=0&id=41045744&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports